import * as React from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import useTestStore from '../../stores/testStore';
const StatContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
}));

const StatRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexWrap: 'wrap',
  gap: theme.spacing(2),
}));

const StatItem = styled(TextField)(({ theme }) => ({
  flex: '1 1 200px',
  minWidth: '200px',
}));

export default function TestSocialDetails() {
  const testDoc = useTestStore(state => state.testDoc);
  
  const stats = [
    {
      id: 'aveCTR',
      label: 'Average CTR',
      value: testDoc.totalLoads?.length > 0 
        ? `${((testDoc.totalViews.length / testDoc.totalLoads.length) * 100).toFixed(1)}%` 
        : '0%',
    },
    {
      id: 'aveWatchtime',
      label: 'Average Watchtime',
      value: testDoc.totalViews?.length > 0 
        ? `${(testDoc.totalWatchtime / testDoc.totalViews.length).toFixed(2)}s` 
        : '0s',
    },
    {
      id: 'totalViews',
      label: 'Total Views',
      value: testDoc.totalViews?.length ?? 0,
    },
    {
      id: 'totalLoads',
      label: 'Total Loads',
      value: testDoc.totalLoads?.length ?? 0,
    },
    {
      id: 'uniqueLoads',
      label: 'Unique Loads',
      value: testDoc.uniqueLoads?.length ?? 0,
    },
    {
      id: 'totalWatchtime',
      label: 'Total Watchtime',
      value: testDoc.totalWatchtime ?? 0,
    },
    {
      id: 'likes',
      label: 'Likes',
      value: testDoc.likes?.length ?? 0,
    },
    {
      id: 'comments',
      label: 'Comments',
      value: testDoc.comments?.length ?? 0,
    },
  ];

  return (
    <StatContainer>
      <Typography variant="subtitle1" gutterBottom>
        Performance Metrics
      </Typography>
      
      <StatRow>
        {stats.map((stat) => (
          <StatItem
            key={stat.id}
            id={stat.id}
            label={stat.label}
            value={stat.value}
            variant="filled"
            InputProps={{
              readOnly: true,
            }}
          />
        ))}
      </StatRow>
    </StatContainer>
  );
}